import React from 'react';
import { string, func } from 'prop-types';

import { noop } from '@ajaibid/utils';
import Button from 'Component/Ajaib/ButtonV2';
import useField from './hooks/useField';

const SubmitButton = (props) => {
  const { defaultValue, id, name, onClick, type, ...btnProps } = props;
  const [, { submitForm }] = useField(name, {
    defaultValue,
  });

  const handleClick = (event) => {
    if (type === 'submit') {
      submitForm();
    }
    onClick(event);
  };

  return (
    <Button name={name} data-testid={id} id={id} type={type} onClick={handleClick} {...btnProps} />
  );
};

SubmitButton.propTypes = {
  defaultValue: string,
  id: string,
  name: string,
  type: string,
  onClick: func,
};

SubmitButton.defaultProps = {
  defaultValue: '',
  id: 'btn',
  name: '',
  type: '',
  onClick: noop,
};

export default SubmitButton;
